import React, { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingButton from "@material-ui/lab/LoadingButton/LoadingButton";
import Button from "@material-ui/core/Button";

import { useParams, useLocation, useHistory } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Modal,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Alert,
  Row,
  Spinner,
} from "reactstrap";

import Fab from "Screen/Components/Basic/fab";

import { initReactI18next, useTranslation } from "react-i18next";

import validator from "validator";

import moment from "moment/moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ReactDatetime from "react-datetime";

import { toValueLabel } from "Screen/Components/Basic/util";
import { t } from "../../services/i18n/index";

const AccountsAuthModal = ({
  loading,
  modal,
  close_modal,
  accounts_auth_type,
  accounts,
  dispatch_danger,
  dispatch_post_accounts_auth_code,
}) => {
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const [code, set_code] = useState("");

  return (
    <>
      <Modal
        className="modal-dialog-centered"
        size="md"
        isOpen={modal}
        toggle={() => {
          close_modal();
        }}
      >
        <div className="modal-header justify-content-center pb-0">
          <h4 className="title title-up mt-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                close_modal();
              }}
            >
              <i className="nc-icon nc-simple-remove" />
            </button>
           
            {t("コードを入力")}
          </h4>
        </div>
        <div className="modal-body">
          <Container>
            <Row>
              <Col md="12">
                <TextField
                  value={code}
                  onChange={(event) => set_code(event.target.value)}
                  id="standard-basic"
                  label={t("コード")}
                  style={{ width: "100%" }}
                  variant="standard"
                  margin="dense"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="modal-footer justify-content-center">
          <Container>
            <Row className="buttons-row">
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    style={{ backgroundColor: primary }}
                    onClick={() => {
                      dispatch_post_accounts_auth_code(
                        {
                          type: accounts_auth_type,
                          code,
                        },
                        () => {
                          close_modal();
                        }
                      );
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("決定")}
                  </LoadingButton>
                </FormGroup>
              </Col>
              <Col md="6" sm="6">
                <FormGroup>
                  <LoadingButton
                    onClick={() => {
                      close_modal();
                    }}
                    pending={loading}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      width: "100%",
                      // backgroundColor: primary,
                      // color: "white",
                    }}
                  >
                    {t("キャンセル")}
                  </LoadingButton>
                </FormGroup>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
};

export default AccountsAuthModal;
